import { render, staticRenderFns } from "./CreatePostPhotoButton.vue?vue&type=template&id=ebef7a82&"
import script from "./CreatePostPhotoButton.vue?vue&type=script&lang=js&"
export * from "./CreatePostPhotoButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports